<template>
<div>
  <div class="clearfix registerwrap" v-if="!popupActivo"  @click="popupActivo =false">
    
    <div class="vx-card__title mb-4">
                  <h4>Create Account</h4>
                  <p>Fill the below form to create a new account.</p>
                </div>
   <div class="faild_section">
     <!-- <label>Login Failed!</label>-->
      <p v-if="error_msg!=''" v-html="error_msg">
      
      
      </p>
    </div>
    <br v-if="error_msg!=''">
    <div class="form-group"> 
      <input
      
        @keyup.enter="registerUserJWt"
        v-validate="'required'"
        data-vv-as="Name"     
        name="name"
        placeholder="Name*"
        v-model="createObject.name"
        class="w-full form_input" />
      <span class="text-danger text-sm">{{ errors.first("name") }}</span>
    </div>
    <div class="form-group">
    <input
     @keyup.enter="registerUserJWt"
      v-validate="'required|min:2'"
      name="companyName"
       data-vv-as="Company Name" 
      placeholder="Company Name*"
      v-model="createObject.companyName"
      class="w-full form_input"
    />
    <span class="text-danger text-sm">{{ errors.first("companyName") }}</span>
    </div>
    <div class="form-group">
    <input
     @keyup.enter="registerUserJWt"
      v-validate="'required|email'"
      name="email"
      data-vv-as="Email" 
      
      placeholder="Email*"
      v-model="createObject.email"
      class="w-full form_input"
    />
    <span class="text-danger text-sm">{{ errors.first("email") }}</span>
    </div>
    <div class="form-group">
    <!--<vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="phone number"
      type="phone number"
      label-placeholder="phone number"
      placeholder="phone number"
      v-model="createObject.phone"
      class="w-full mt-6" />-->
    <VuePhoneNumberInput
     :disabled-fetching-country="true"
     @keyup.enter="registerUserJWt"
      :default-country-code="defaultcountry"
      v-validate="'required'"
      data-vv-name="Phone number"
       data-vv-as="Phone Number"
      placeholder="phone number"
      :no-example="true"
      @update="updatePhoneNumber"
       @input="onPhoneNumber"
      :required="true"
      v-model="createObject.phone"
       v-bind="vuePhone.props"
    />

     <span class="text-danger text-sm"   v-show="loadCount>2&&!isPhoneValid && !errors.has('Phone number')" >*Invalid phone number - Please enter a valid one</span>
     <span class="text-danger text-sm" v-show="loadCount>2&&errors.has('Phone number')">{{ errors.first("Phone number") }}</span>
      
    </div>
    <div class="form-group">
      <input
       @keyup.enter="registerUserJWt"
        ref="password"
        type="password"
        v-validate="'required|min:6|max:10'"
        name="password" 
         data-vv-as="Password"
        placeholder="Password*"
        v-model="createObject.pwd"
        class="w-full form_input"
      />
      <span class="text-danger text-sm">{{ errors.first("password") }}</span>
    </div>
    <div class="form-group">
      <input
       @keyup.enter="registerUserJWt"
        type="password"
        v-validate="'min:6|max:10|confirmed:password'"
        data-vv-as="Confirm Password"
        name="confirmPwd" 
        placeholder="Confirm Password*"
        v-model="createObject.confirmPwd"
        class="w-full form_input"
      />
      <span class="text-danger text-sm">{{ errors.first("confirmPwd") }}</span>
    </div>
     
    <vs-checkbox v-model="createObject.isTermsConditionAccepted" class="mt-6"
      >I accept the terms & conditions.</vs-checkbox
    >
    <div class="d-flex justify-content-between align-center mt-1">
      <!-- <vs-button  type="border" to="/pages/login" class="mt-6">Login</vs-button> -->
      <p class="register_text">
        If you are already a registered customer, please
        <router-link to="/login"> Login</router-link> here
      </p>
     
      <vs-button
        class="float-right primary_btn"
        @click="registerUserJWt"
        :disabled="!validateForm"
        >Register</vs-button
      >
       
    
    </div>
   
  </div>

  <div class="register_sucess" v-if="popupActivo" >
    <figure><img
          src="@/assets/images/pages/checked.svg"
          alt="register"
          class="mx-auto"
        /></figure>
    <p> Congratulations on your successful registration with Customer Portal.
        </p>
        <br>
        <div class="login_btn">
                <router-link to="/login" class="primary_btn"> Login</router-link> 
        </div>
  </div>
</div>
</template>

<script>
import Button from '../../components/vuesax/button/Button.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
export default {
  components: { Button, VuePhoneNumberInput },
  data () {
    return {
      vuePhone:{
        props:{
          translations:{
            phoneNumberLabel:"Phone Number"
          }
        }

      },
      loadCount:0,
      isPhoneValid:true,
      defaultcountry:null,
      error_msg:'',
      createObject: {
        name: '',
        email: '',
        companyName: '',
        pwd: '',
        phoneCode: '91',
        phone: '',
        confirmPwd: '',
        isTermsConditionAccepted: true,
        phoneCountryCode:{countryCode:'',countryCallingCode:''},
      },

      select1Normal: '',
      popupActivo: false,
      phoneShowError: false,
      options1: [
        { text: 'IT', value: 0 },
        { text: 'Blade Runner', value: 2 },
        { text: 'Thor Ragnarok', value: 3 }
      ]
    }
  },
  mounted () {

    var _self = this;
       _self.phoneShowError = false;

     fetch("https://ip2c.org/s")
     .then(function(response) {
    return response.text();
  }).then( function(datas){
      if(datas){
        var _ip2cdata = datas.split(';')
        _self.defaultcountry = _ip2cdata[1]
 _self.$validator.reset()

        setTimeout(function(){
        },250)
      }
  
    });

  },
  computed: {
    validateForm () {
      return (
        !this.errors.any() && this.createObject.name !== '' && 
        this.createObject.companyName !== '' &&
          this.createObject.email !== '' &&
          this.createObject.pwd !== '' &&
          this.isPhoneValid &&
          this.createObject.confirmPwd !== '' &&
          this.createObject.isTermsConditionAccepted === true
      )
    }
  },
  methods: {
    prueba () {
      console.log('prueba de focsu')
    },
    registerUserJWt () {
      // If form is not validated or user is already login return
      this.popupActivo =false;
      if (!this.validateForm) return

      const payload = {
        userDetails: this.createObject,
        notify: this.$vs.notify
      }
     
       this.$vs.loading();
      this.$store
        .dispatch('auth/registerUserJWT', payload)
        .then((res) => {
          this.popupActivo =true
          this.resetForm();
       

          this.$vs.loading.close()
          
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.error_msg =error.message;
        
          
          if (error.code) {
            if (error.code == 'NOT_SAME_NAME') {
               this.$vs.loading();
              payload.userDetails.companyName = error.name
              //if (confirm(error.message)) {
                this.$store
                  .dispatch('auth/registerUserJWT', payload)
                  .then((res) => {
                    this.resetForm();
                    this.popupActivo =true;
                    this.$vs.loading.close();
                    /*
                    this.$vs.notify({
                      title: 'Success',
                      text: res.message,
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      position: 'top-right',
                      color: 'success'
                    }) */
                  })
                  .catch((error) => {
                    this.$vs.loading.close()
                   /*
                   this.$vs.notify({
                      title: 'Error',
                      text: error.message,
                      position: 'top-right',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                    }) */
                  })
             // }
            } else {
              this.$vs.loading.close()
              this.error_msg =error.message;
             /* this.$vs.notify({
                title: 'Error',
                text: error.message,
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              }) */
            }
          } else {
            this.$vs.loading.close()
            this.error_msg =error.message;
            /*
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            }) */
          }
         
        })
    },
    updatePhoneNumber (item) {
      // this.isPhoneValid =true;
      if (item.isValid) {
          this.isPhoneValid =true;
        this.createObject.phoneCode = item.countryCallingCode
        this.createObject.phone = item.nationalNumber
        this.createObject.phoneCountryCode = {countryCode:item.countryCode,countryCallingCode:item.countryCallingCode}; 
      }else{
         this.isPhoneValid =false;
      }
      this.loadCount =this.loadCount+1;
    },


    showerrorNot (error) {
      this.$vs.loading.close()
      this.$vs.notify({
        title: 'Error',
        text: error.message,
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    },
    resetForm () {
      this.phoneShowError = false;
      this.createObject = {
        name: '',
        email: '',
        companyName: '',
        pwd: '',
        phoneCode: '91',
        phone: '',
        confirmPwd: '',
        isTermsConditionAccepted: true
      }
    },
    onPhoneNumber(item) {
      if (this.createObject.phone && this.createObject.phone.length > 1) {
        var phone = this.createObject.phone.replace(/\s+/g, "")
        if (phone.length < 10 || phone.length > 15) {
          this.phoneShowError = true;
        } else {
         this.phoneShowError = false;         
        }
      } else {
         this.phoneShowError = false;         
      }
    },
  }
}
</script>
